const FEATURE_HELP_URLS = {
  agent_bots: 'https://escaleshop.com.br/hc/agent-bots',
  agents: 'https://escaleshop.com.br/hc/agents',
  audit_logs: 'https://escaleshop.com.br/hc/audit-logs',
  campaigns: 'https://escaleshop.com.br/hc/campaigns',
  canned_responses: 'https://escaleshop.com.br/hc/canned',
  channel_email: 'https://escaleshop.com.br/hc/email',
  channel_facebook: 'https://escaleshop.com.br/hc/fb',
  custom_attributes: 'https://escaleshop.com.br/hc/custom-attributes',
  dashboard_apps: 'https://escaleshop.com.br/hc/dashboard-apps',
  help_center: 'https://escaleshop.com.br/hc/help-center',
  inboxes: 'https://escaleshop.com.br/hc/inboxes',
  integrations: 'https://escaleshop.com.br/hc/integrations',
  labels: 'https://escaleshop.com.br/hc/labels',
  macros: 'https://escaleshop.com.br/hc/macros',
  reports: 'https://escaleshop.com.br/hc/reports',
  sla: 'https://escaleshop.com.br/hc/sla',
  team_management: 'https://escaleshop.com.br/hc/teams',
  webhook: 'https://escaleshop.com.br/hc/webhooks',
  billing: 'https://escaleshop.com.br/pricing',
  saml: 'https://escaleshop.com.br/hc/saml',
  captain_billing: 'https://escaleshop.com.br/hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
